import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const CoursPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { user } = useAuth();

    // Rediriger vers login si non connecté
    React.useEffect(() => {
        if (!user) {
            navigate('/login');
        }
    }, [user, navigate]);

    if (!user) {
        return null;
    }

    return (
        <div style={{ padding: '40px 20px', maxWidth: '1200px', margin: '0 auto' }}>
            <button 
                onClick={() => navigate('/dashboard')}
                style={{
                    padding: '10px 20px',
                    background: 'white',
                    color: '#667eea',
                    border: '2px solid #667eea',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    marginBottom: '30px',
                    fontWeight: '600'
                }}
            >
                ← Retour au Dashboard
            </button>

            <h1 style={{ fontSize: '32px', marginBottom: '20px' }}>
                Cours de la Formation #{id}
            </h1>

            <div style={{
                background: '#f8f9fa',
                padding: '60px 40px',
                borderRadius: '12px',
                textAlign: 'center'
            }}>
                <div style={{ fontSize: '80px', marginBottom: '20px' }}>🎓</div>
                <h2>Contenu de la formation</h2>
                <p style={{ color: '#718096', marginTop: '15px' }}>
                    Cette section sera développée prochainement avec les chapitres,
                    vidéos et documents de formation.
                </p>
            </div>
        </div>
    );
};

export default CoursPage;